export default {
    topics: [
        {
            title: ' ZipFile ',
            href: 'm-ZipFile-ZipFile.html',
            attributes: { 'data-id': 'm-ZipFile-ZipFile' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-ZipFile-d66e5240',
            topics: [],
        },
        {
            title: ' dispose ',
            href: 'm-ZipFile-dispose.html',
            attributes: { 'data-id': 'm-ZipFile-dispose' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-dispose-d66e5248',
            topics: [],
        },
        {
            title: ' fileCount ',
            href: 'p-ZipFile-fileCount.html',
            attributes: { 'data-id': 'p-ZipFile-fileCount' },
            menu: { hasChildren: false },
            tocID: 'p-ZipFile-fileCount-d66e5256',
            topics: [],
        },
        {
            title: ' getEntry ',
            href: 'm-ZipFile-getEntry.html',
            attributes: { 'data-id': 'm-ZipFile-getEntry' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-getEntry-d66e5264',
            topics: [],
        },
        {
            title: ' open ',
            href: 'm-ZipFile-open.html',
            attributes: { 'data-id': 'm-ZipFile-open' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-open-d66e5272',
            topics: [],
        },
        {
            title: ' save ',
            href: 'm-ZipFile-save.html',
            attributes: { 'data-id': 'm-ZipFile-save' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-save-d66e5280',
            topics: [],
        },
        {
            title: ' setEntry ',
            href: 'm-ZipFile-setEntry.html',
            attributes: { 'data-id': 'm-ZipFile-setEntry' },
            menu: { hasChildren: false },
            tocID: 'm-ZipFile-setEntry-d66e5288',
            topics: [],
        },
    ],
};

